/** PostHog feature flag: web checklist + live photo review queue */
export const FIC_CHECKLIST_WEB_FEATURE_FLAG = "fic-checklist-web";

/** PostHog feature flag: Submit ITEL flow (roof material question on Review and approve photos, Submit/Receive ITEL tasks) */
export const SUBMIT_ITEL_FEATURE_FLAG = "submit-itel";

/** PostHog feature flag: show the insurance view — top-level nav item + insurance Views sub-items (off hides them) */
export const INSURANCE_VIEW_FEATURE_FLAG = "insurance-view-enabled";

/** PostHog feature flag: customer appeasements workflow */
export const CUSTOMER_APPEASEMENTS_FEATURE_FLAG = "customer-appeasements";

/** PostHog feature flag: homeowner portal color selection wizard */
export const PORTAL_COLOR_SELECTION_FEATURE_FLAG = "portal-color-selection";

/** PostHog feature flag: homeowner status timeline on partner flows without a registered timeline */
export const GENERAL_HOMEOWNER_STATUS_TIMELINE_FLAG = "general-homeowner-status-timeline";

/** PostHog feature flag: Ensite site-survey integration (accept-work-order UI + create-survey webhook) */
export const ENSITE_INTEGRATION_FEATURE_FLAG = "ensite-integration";

/** PostHog feature flag: Remittance table — contractor AP schedule + payout view */
export const REMITTANCE_TABLE_FEATURE_FLAG = "remittance-table";

/** PostHog feature flag: site-visit photo annotation (notes + tags on bid site-visit photos). */
export const SITE_VISIT_PHOTO_ANNOTATION_FEATURE_FLAG = "site-visit-photo-annotation";

/** PostHog feature flag: spawn the CREATE_VENDOR_CREDITS task from appeasement creation + corrections WO finalization */
export const CREATE_VENDOR_CREDITS_SPAWN_FEATURE_FLAG = "create-vendor-credits-spawn";

/**
 * PostHog feature flag: gate + configure vendor-credit auto-apply. Carries a JSON payload
 * `{ mode: "OFF" | "LOG_ONLY" | "LIVE", cutoverAt?: ISO date }`. Read fail-closed (off/absent → OFF).
 */
export const VENDOR_CREDIT_AUTO_APPLY_FEATURE_FLAG = "vendor-credit-auto-apply";

/** PostHog feature flag: quoting sandbox tool (admin nav link, list + editor pages, sandboxQuoting procedures). Targets internal users by email. */
export const QUOTING_SANDBOX_FEATURE_FLAG = "quoting-sandbox";

/** PostHog feature flag: site-visit scheduling on first call (COLLECT_HOMEOWNER_AVAILABILITY task + SOW-drawer availability section) */
export const SITE_VISIT_SCHEDULING_FEATURE_FLAG = "site-visit-scheduling";

/** PostHog feature flag: Nomad (internal) site-inspection scheduling — gates the confirm-contractor tryToBook capacity check for internal inspection orgs. */
export const NOMAD_SCHEDULING_FEATURE_FLAG = "nomad-scheduling";

/** PostHog feature flag: hourly sweep that marks a Nomad visit MISSED once its block ends unstarted and auto-schedules it again. */
export const NOMAD_MISSED_VISIT_RESCHEDULE_FEATURE_FLAG = "nomad-missed-visit-reschedule";

/** PostHog feature flag: route PandaDoc document.completed side effects through the durable handle-pandadoc-document-completion Inngest function instead of the inline webhook chain */
export const PANDADOC_COMPLETION_VIA_INNGEST_FEATURE_FLAG = "pandadoc-completion-via-inngest";

/** PostHog feature flag: account-wide kill-switch for the Inspectify integration client (create-order + read endpoints) */
export const INSPECTIFY_FEATURE_FLAG = "inspectify-feature-flag";

export const CONTRACTOR_BLOCKING_CARDS_FEATURE_FLAG = "contractor-blocking-cards";

/** PostHog flag gating specialist-line resolution for in-window automated homeowner SMS. Property-filtered
 * on partnerFlow, not person-keyed — the send path runs as REMI_AUTOMATIONS, so a person-keyed flag would
 * evaluate against the bot. */
export const SPECIALIST_WINDOW_SENDER_FEATURE_FLAG = "specialist-window-sender";

/** PostHog feature flag: live-call widget (connect unknown callers to a bid) — limited rollout */
export const LIVE_CALL_WIDGET_FEATURE_FLAG = "live-call-widget";

/** PostHog feature flag: My Queue page + nav entry */
export const MY_QUEUE_FEATURE_FLAG = "my-queue";

/** PostHog feature flag: My daily actions page + nav entry + home redirect */
export const MY_DAILY_ACTIONS_FEATURE_FLAG = "my-daily-actions";

/** PostHog feature flag: Eden nav entry — pilot rollout. Key stays `agent-cockpit`: a new key would drop enrolled pilots. */
export const AGENT_EDEN_FEATURE_FLAG = "agent-cockpit";

/** PostHog feature flag: shared proxy-phone pool allocation at confirm-contractor. Off → legacy 1:1 per-phone allocation. */
export const SHARED_PROXY_POOL_FEATURE_FLAG = "shared-proxy-pool-allocation";

/** Dark-deploy gate: flip to honor a STOP to ANY Remi line as point-of-contact
 *  intro suppression, since a fresh AM line can never match a homeowner's prior STOP to another line.
 *  Typed `boolean` (not literal `false`) so `if (CROSS_LINE_STOP_HONORED)` is not a dead branch. */
export const CROSS_LINE_STOP_HONORED: boolean = false;

export const MANUAL_DATES_LOCKDOWN_FEATURE_FLAG = "manual-dates-lockdown";

/** PostHog feature flag: Openly quote PDF tear-out/replace layout. Keep it a global on/off — the stored
 * PDF renders as REMI_AUTOMATIONS while the browser preview renders as the logged-in user, so a
 * percentage or cohort rollout evaluates two identities and desyncs the two renders. */
export const OPENLY_TEAR_OUT_REPLACE_FEATURE_FLAG = "openly-tear-out-replace";

export const MFA_ENFORCEMENT_FEATURE_FLAG = "mfa-enforcement";

export const MFA_ENROLLMENT_PROMPT_FEATURE_FLAG = "mfa-enrollment-prompt";

/** PostHog feature flag: file Sunrun redesign SLA-breach tickets (NSYNC-7607). Keep it a global on/off —
 * the sweep runs as REMI_AUTOMATIONS, so a percentage rollout evaluates one identity for every project. */
export const SUNRUN_REDESIGN_SLA_TICKETS_FEATURE_FLAG = "sunrun-redesign-sla-tickets";

/** PostHog feature flag: gate XA estimate mismatch automated ticket creation (Westhill scraper → oddjob-api).
 * Keep it a global on/off — the caller is REMI_AUTOMATIONS, so a person-keyed flag evaluates one identity for every project. */
export const XA_ESTIMATE_MISMATCH_TICKETS_FEATURE_FLAG = "xa-estimate-mismatch-tickets";

/** PostHog feature flag: let an XA assignment's header total stand in for a missing correction row in the
 * estimate mismatch check. Keep it a global on/off — the caller is REMI_AUTOMATIONS. */
export const XA_ASSIGNMENT_TOTAL_MISMATCH_TICKETS_FEATURE_FLAG = "xa-assignment-total-mismatch-tickets";

/** PostHog feature flag: gate ticket creation for a quote priced off a superseded XA estimate.
 * Keep it a global on/off — the caller is REMI_AUTOMATIONS. */
export const SUPERSEDED_QUOTE_ANCHOR_TICKETS_FEATURE_FLAG = "superseded-quote-anchor-tickets";

/** PostHog feature flag: kill switch for storm auto-resolution of DOES_NOT_NEED_RESPONSE conversations.
 * Keep it a global on/off — the storm runs as REMI_AUTOMATIONS, so a percentage/cohort rollout evaluates
 * one identity for every conversation. Enabled = feature on; disable to kill. */
export const AUTO_RESOLVE_NO_RESPONSE_NEEDED_FEATURE_FLAG = "auto-resolve-no-response-needed";

/** PostHog feature flag: kill switch for the cron that reconciles Remi resolved with OpenPhone Done.
 * Keep it a global on/off: the cron runs as REMI_AUTOMATIONS, so a percentage/cohort rollout evaluates
 * one identity for every line. Enabled = cron runs; disable to kill. */
export const RECONCILE_CONVERSATIONS_WITH_OPEN_PHONE_FEATURE_FLAG = "reconcile-conversations-with-open-phone";

/** PostHog feature flag: unresolve a conversation when an inbound call goes unanswered.
 * Keep it a global on/off — the unresolve runs as REMI_AUTOMATIONS, so a percentage/cohort rollout evaluates
 * one identity for every call. Enabled = feature on; disable to kill. */
export const UNRESOLVE_CONVERSATION_ON_MISSED_CALL_FEATURE_FLAG = "unresolve-conversation-on-missed-call";

export const PRE_NTP_CONVERSATION_OWNERSHIP_FEATURE_FLAG = "pre-ntp-conversation-ownership";

/** Keep it a global on/off — the claim path runs as REMI_AUTOMATIONS, so a percentage rollout
 * evaluates one identity for every financing. */
export const CLAIM_FINANCING_FEATURE_FLAG = "claim-financing";

/** PostHog feature flag: the TaskSummarySection AI-generated summary subsection on the internal task
 * details page (AM pilot). Flag off renders nothing. */
export const TASK_SUMMARY_FEATURE_FLAG = "task-summary";
/** PostHog feature flag: gate the history-backed project activity feed tab during rollout. Person-keyed
 * on purpose — the flag is read in the browser by the viewing user, so a percentage rollout gives a
 * stable per-person cohort rather than one identity for everyone. */
export const PROJECT_HISTORY_FEED_FEATURE_FLAG = "project-history-feed";
/** PostHog feature flag: per-PV-system "Partial R&R" toggle on the quoting tool's solar tab. Gates the
 * control only — the column and its read path stay live, so a value set while the flag was on survives
 * the flag being turned off. */
export const PARTIAL_RNR_FEATURE_FLAG = "partial-rnr";

export const WORKSITE_COVERAGE_BANNER_FEATURE_FLAG = "worksite-coverage-banner";

/** PostHog feature flag: the Create QA visit entry point on ProjectHeader. Off until a checklist
 * submission can reach attachQaChecklistSubmission — without that writer ASSESS_QA_RESULTS can never
 * close, and an open QA child holds its parent bid out of DONE (GAD-321). */
export const QA_VISIT_CREATION_FEATURE_FLAG = "qa-visit-creation";

/** PostHog feature flag: auto-fill the spare capacity a dispatch build leaves on QA-capable inspectors
 * with QA visits. Separate from `nomad-scheduling`, which gates the solver itself — off, QA visits stay
 * in the queue for a dispatcher to place by hand rather than riding along with every build. */
export const NOMAD_QA_AUTOFILL_FEATURE_FLAG = "nomad-qa-autofill";

/** PostHog feature flag: the daily job that creates QA visits for the top QA recommendations. Keep it a
 * global on/off — the job runs as REMI_AUTOMATIONS, so a percentage rollout hashes one bot identity. Off,
 * recommendations are only acted on by hand from the dispatch board's QA recommendations drawer. */
export const QA_VISIT_AUTO_CREATION_FEATURE_FLAG = "qa-visit-auto-creation";

/** PostHog feature flag: under `qa-visit-auto-creation`, create one geographic cluster of QA visits per run and
 * text each homeowner for an unattended walkthrough. Stays off for 12h after the deploy adding
 * QA_WALKTHROUGH_REQUEST_HOMEOWNER, which an instance on the old build cannot read. Global on/off. */
export const QA_VISIT_WALKTHROUGH_TEXTS_FEATURE_FLAG = "qa-visit-walkthrough-texts";

/** PostHog feature flag: render the QA report onto the corrections an ops decision links. Stays off for 12h
 * after the deploy adding FileTag.QA_REPORT: FileToFileTag reads parse tagId strictly, so an instance still on
 * the old build throws on any file carrying it. Global on/off — it is evaluated against whichever ops user decided. */
export const QA_REPORT_PDF_FEATURE_FLAG = "qa-report-pdf";

/** PostHog feature flag: the Jev corrections check in shadow mode, which logs to Axiom and never creates a task.
 * Keep it a global on/off — the check runs as REMI_AUTOMATIONS, so a percentage rollout hashes one bot identity. */
export const CORRECTIONS_JEV_SHADOW_FEATURE_FLAG = "corrections-jev-shadow";

/** PostHog feature flag: contractor daily driver — Today plate plus the Volume, Benefits and supply-console prototypes */
export const CONTRACTOR_DAILY_DRIVER_FEATURE_FLAG = "contractor-daily-driver";

/** PostHog feature flag: the Today page's job-order sections with a deadline column, in place of the SLA-ring stage stack */
export const CONTRACTOR_TODAY_V2_FEATURE_FLAG = "contractor-today-v2";

/** PostHog feature flag: the Missing SLA targets badge and warning on Preferred contractors ahead of accrual in Confirm Contractor */
export const CONTRACTOR_SLA_WARNING_FEATURE_FLAG = "contractor-sla-warning";

/** PostHog feature flag: the AI site-discovery summary posted into the contractor thread. Property-filtered
 * on `contractorOrgId` and `partnerFlow`, never a percentage rollout — the post runs as REMI_AUTOMATIONS,
 * so the rollout percentage hashes one bot identity and resolves to all or nothing. */
export const SITE_DISCOVERY_SUMMARY_FEATURE_FLAG = "site-discovery-summary";

/** PostHog feature flag: text and push a site inspector when a visit on their route is added for today,
 * moved, or removed. */
export const SITE_INSPECTOR_SCHEDULE_NOTIFICATIONS_FEATURE_FLAG = "site-inspector-schedule-notifications";

/** PostHog feature flag: automated homeowner texts for Nomad site inspections and QA visits — the
 * inspector-on-the-way text and the inspection-completed text. */
export const NOMAD_HOMEOWNER_TEXTS_FEATURE_FLAG = "nomad-homeowner-texts";

/** PostHog feature flag: auto-complete FINALIZE_WORK_ORDER for Remi Labor Only projects. Evaluated as REMI_AUTOMATIONS. */
export const RLO_FINALIZE_WORK_ORDER_AUTOCOMPLETE_FEATURE_FLAG = "rlo-finalize-work-order-autocomplete";

/** PostHog feature flag: while off, no Certificate of Completion invoice is generated or sent to the partner. On or
 * off for everyone, never a percentage rollout — the invoice delivery runs as REMI_AUTOMATIONS, so a percentage
 * hashes one bot identity and resolves to all or nothing. */
export const COC_PARTNER_INVOICE_FEATURE_FLAG = "coc-partner-invoice";

/** PostHog feature flag: the Quo worksite-contacts menu in the Bid, Project, Task, Ticket and conversation headers.
 * Off keeps the legacy "+" start-conversation button on the Bid Homeowner tab; while PostHog is still
 * resolving the flag neither control renders, so a flagged-in user never sees the "+" flash. */
export const WORKSITE_CONTACTS_MENU_FEATURE_FLAG = "worksite-contacts-menu";

export const SOW_CHANGE_FLOW_FEATURE_FLAG = "sow-change-flow";

/** PostHog feature flag: redesigned checklist experience in the mobile app. Targeted at site inspectors; everyone
 * else stays on the legacy screens. */
export const MOBILE_CHECKLIST_REDESIGN_FEATURE_FLAG = "mobile-checklist-redesign";

/** PostHog feature flag: the mobile app queues every checklist photo on the device and uploads it only
 * through the offline sync, instead of uploading inline while online. */
export const MOBILE_LOCAL_FIRST_PHOTO_CAPTURE_FEATURE_FLAG = "mobile-local-first-photo-capture";

export const UNIFIED_SIDEBAR_FEATURE_FLAG = "unified-sidebar";

export const REVIEW_BID_GUIDE_FEATURE_FLAG = "review-bid-guide";

/** PostHog feature flag: Remi acts on the Review Bid guide outcome instead of only showing it. */
export const REVIEW_BID_GUIDE_OUTCOME_ACTIONS_FEATURE_FLAG = "review-bid-guide-outcome-actions";

/** PostHog feature flag: capture Sunrun portal screenshots when Review Bid is created. */
export const REVIEW_BID_PORTAL_CAPTURE_FEATURE_FLAG = "review-bid-portal-capture";

/** PostHog feature flag: contractor work order concession requests (travel and job size adders, scope reports).
 * Read in production only; every other environment, E2E included, treats it as on. Keyed on the requesting contractor. */
export const WORK_ORDER_CONCESSIONS_FEATURE_FLAG = "concessions-work-order";

export const HISTORY_OUTBOX_SEND_FEATURE_FLAG = "history-outbox-send";

/** PostHog feature flag: gates the hourly job that texts contractors and the Job texts settings toggle.
 * Keep it a plain on/off flag: the job evaluates it as REMI_AUTOMATIONS and the toggle per user. */
export const CONTRACTOR_JOB_TEXTS_FEATURE_FLAG = "contractor-job-texts";

/** PostHog feature flag: shows the Push column in notification settings, and with it the job texts Push toggle. Keyed per user. */
export const CONTRACTOR_JOB_TEXTS_PUSH_FEATURE_FLAG = "contractor-job-texts-push";

/** PostHog feature flag: Eden serves real agent-action suggestions to this person in production. Keyed on the person id. */
export const EDEN_AGENT_ACTION_SUGGESTIONS_FEATURE_FLAG = "eden-agent-action-suggestions";

/** PostHog feature flag: Eden shows this person Gray Box's thread-reply and callback drafts. Keyed on the person id.
 * Drafts are generated for every owned thread whether or not its owner has the flag. */
export const THREAD_REPLY_SUGGESTIONS_FEATURE_FLAG = "thread-reply-suggestions";

/** PostHog feature flag: the kill switch for Gray Box thread-reply generation. Off in production until set; always on
 * locally and in preview. Evaluated as the automations bot, so it is all or nothing: never target it by person. */
export const THREAD_REPLY_GENERATION_FEATURE_FLAG = "thread-reply-generation";

export const HISTORY_SLA_BACKFILL_PAUSED_FEATURE_FLAG = "history-sla-backfill-paused";

export const SLA_DEFINITIONS_FEATURE_FLAG = "sla-definitions";

// Keep it global: each caller evaluates it as itself (the scan as REMI_AUTOMATIONS, rescores and manual flags
// as the person), so targeting by person, cohort or percentage makes their tiers disagree and flip-flop.
export const ESCALATION_HOT_GATE_FEATURE_FLAG = "escalation-hot-gate";

export const VIEW_AI_TICKET_COMMENTS_FEATURE_FLAG = "view-ai-ticket-comments";

/** PostHog feature flag: email a training contractor's admin their sandbox invite when provisioning creates or adopts the
 * contractor. Keep it a global on/off — provisioning runs as REMI_AUTOMATIONS, so a percentage rollout evaluates one
 * identity for every contractor. */
export const TRAINING_INVITE_EMAILS_FEATURE_FLAG = "training-invite-emails";
